import axios from "axios";
import Cookies from "universal-cookie";
import { createBrowserHistory } from "history";
import { Slide, ToastContainer, toast } from "react-toastify";
import React, { useEffect, useState } from "react";
import { Carousel } from "react-responsive-carousel";
import "react-responsive-carousel/lib/styles/carousel.min.css";
import "react-toastify/dist/ReactToastify.css";
import loadingSvg from "../assets/loading.svg";
import { v4 as uuidv4 } from "uuid";
import config from "../config.json";
import { QuestionInterFace } from "../interfaces/QuestionInterface";
import Question from "../components/Question/Question";
import MeetingHeader from "../components/MeetingHeader/MeetingHeader";
import { useNavigate, useParams } from "react-router-dom";
import ActivitiesSection from "../components/PageSections/KatalifeFree/ActivitiesSection";
import DownloadApp from "../components/DownloadApp";
import GrowthSection from "../components/PageSections/KatalifeFree/GrowthSection";
import ActivityProgressSection from "../components/PageSections/KatalifeFree/ActivityProgressSection";
import ShareFeedbackSection from "../components/PageSections/KatalifeFree/ShareFeedbackSection";
import Hero from "../components/Hero";
import TopUI from "../components/TopUI";
type objType = {
  [key: string]: number;
};

const cookies = new Cookies();
const history = createBrowserHistory();
function getMobileOperatingSystem(): string {
  const userAgent: string =
    navigator.userAgent || navigator.vendor || (window as any).opera;

  // iOS detection
  if (/iPad|iPhone|iPod/.test(userAgent) && !(window as any).MSStream) {
    return config["FEEDBACK-UI-APPSTORE-URL"];
  }
  // Android detection
  else if (/android/i.test(userAgent)) {
    return config["FEEDBACK-UI-PLAYSTORE-URL"];
  }

  return config["FEEDBACK-UI-APPSTORE-URL"];
}
function RatingPage() {
  const [activeQuestionIndex, setActiveQuestionIndex] = useState(0);
  const [showConfirmation, setShowConfirmation] = useState(false);
  const [showNotFoundError, setShowNotFoundError] = useState(false);
  const [showGenericError, setShowGenericError] = useState(false);
  const [showAlreadySubmittedError, setShowAlreadySubmittedError] =
    useState(false);
  const [showExpiredError, setShowExpiredError] = useState(false);
  const [showInputActivityCodeError, setShowInputActivityCodeError] =
    useState(false);
  const [questions, setQuestions] = useState<any[]>([]);
  const [inputValue, setInputValue] = useState("");
  const [eventName, setEventName] = useState("");
  const [description, setDescription] = useState("");
  const [avatar, setAvatar] = useState("");
  const [activityType, setActivityType] = useState("");
  const [activityDateTime, setActivityDateTime] = useState("");
  const [firstName, setFirstName] = useState("");
  const [loading, setLoading] = useState(false);
  const [lastName, setLastName] = useState("");
  const [ratings, setRatings] = useState({});
  const [feedbackCount, setfeedbackCount] = useState("");
  const [activityCount, setactivityCount] = useState("");
  const [verificationRequired, setVerificationRequired] = useState(false);
  const [verified, setVerified] = useState(false);
  const [email, setEmail] = useState('');
  const [otpSent, setOtpSent] = useState(false);
  const [otp, setOtp] = useState('');
  const [verificationToken, setVerificationToken] = useState('');
  const [perpetualFeedback, setPerpetualFeedback] = useState(false);
  const [level, setlevel] = useState("");
  const [countdown, setCountdown] = useState<number | null>(null);
  const [progress, setProgress] = useState<number>(0);
  const { activityCode } = useParams();
  const isData = activityCode && eventName;
  const navigate = useNavigate();
  const [guid] = useState(uuidv4);
  useEffect(() => {
    if (activityCode) {
      hideAllBoxMessages();
      let activityCodes = cookies.get("activityCodes");
      if (activityCodes && activityCodes.includes(activityCode) && !perpetualFeedback && !verificationRequired) {
        setShowAlreadySubmittedError(true);
      } else {
        setLoading(true);
        axios
          .get(
            `${config.KATA_LIFE_API_URL}feedback/${activityCode}/${config["FEEDBACK-UI-QUESTION-COUNT"]}`
          )
          .then((data) => {
            setEventName(data?.data?.eventName);
            setQuestions(data?.data?.questions || []);
            setFirstName(data?.data?.firstName);
            setLastName(data?.data?.lastName);
            setDescription(data?.data?.description);
            setActivityType(data?.data?.activityType);
            setActivityDateTime(data?.data?.activityDateTime);
            setAvatar(data?.data?.avatar);
            setfeedbackCount(data?.data?.feedbackCount);
            setactivityCount(data?.data?.activityCounts);
            setlevel(data?.data?.level);
            setVerificationRequired(data?.data?.verification === 2 || data?.data?.verification === 3);
            setPerpetualFeedback(data?.data?.perpetualFeedback ?? false);
          })
          .catch((error) => {
            //history.push("/");
            if (error.response?.status === 422) {
              setShowExpiredError(true);
            } else if (error.response?.status === 404) {
              setShowNotFoundError(true);
            } else {
              setShowGenericError(true);
            }
          })
          .finally(() => setLoading(false));
      }
    }
  }, [activityCode]);

  function submitRatings(data: any) {
    let activityCodes = cookies.get("activityCodes");
    if (activityCodes) {
      if (activityCodes.includes(activityCode) && !perpetualFeedback) {
        setShowAlreadySubmittedError(true);
        return false;
      } else {
        activityCodes = [...activityCodes, activityCode];
      }
    } else {
      activityCodes = [activityCode];
    }
    activityCodes = JSON.stringify(activityCodes);
    setLoading(true);

    axios
      .post(`${config.KATA_LIFE_API_URL}feedback`, {
        SessionId: guid,
        Answers: data,
        ActivityCode: activityCode,
        Email:email
      })
      .then((response) => {
        cookies.set("activityCodes", activityCodes, { path: "/" });
      })
      .catch((error) => console.log(error))
      .finally(() => setLoading(false));
  }

  function handleRateChange(rating: number, id: string) {
    const currentIndex = questions.findIndex((item) => item.questionId === id);
    const oldRatings: objType = { ...ratings };
    oldRatings[`${questions[currentIndex].questionId}`] = rating;
    setRatings({ ...oldRatings });
    
    // Start progress bar
    setProgress(0);
    const duration = 1000; // Total duration in ms
    const interval = 50; // Update every 50ms
    const steps = duration / interval;
    const increment = 100 / steps;
    
    let currentProgress = 0;
    const progressInterval = setInterval(() => {
      currentProgress += increment;
      if (currentProgress >= 100) {
        setProgress(100);
        clearInterval(progressInterval);
        setTimeout(() => setProgress(0), 100);
      } else {
        setProgress(currentProgress);
      }
    }, interval);
    
    setTimeout(() => {
      if (currentIndex + 1 < questions.length) {
        setActiveQuestionIndex(currentIndex + 1);
      } else {
        submitRatings(oldRatings);
        setShowConfirmation(true);
      }
      clearInterval(progressInterval);
      setProgress(0);
    }, duration);
  }

  function hideAllBoxMessages() {
    setShowAlreadySubmittedError(false);
    setShowExpiredError(false);
    setShowGenericError(false);
    setShowNotFoundError(false);
    setShowInputActivityCodeError(false);
  }
  function handleSendOtp() {
    axios
      .post(`${config.KATA_LIFE_API_URL}feedback/send-otp`, { email })
      .then((res) => {
        toast.success("OTP sent successfully.");
        setOtpSent(true);
        setVerificationToken(res.data.token);
      })
      .catch(() => {
        toast.error("Failed to send OTP. Please check your email.");
      });
  }
  function handleVerifyOtp() {
    axios
      .post(`${config.KATA_LIFE_API_URL}feedback/verify-otp`, {
        email,
        otp,
        token: verificationToken,
      })
      .then(() => {
        toast.success("Email verified successfully.");
        setVerified(true);
      })
      .catch(() => {
        toast.error("Invalid OTP. Please try again.");
      });
  }
  function renderVerification() {
    return (
      <div className="card mt-3 card-shadow mx-3 messagebox verification-box">
        <div className="full-center-container">
          <div className="card-body text-center card-body-verify">
            <p className="question-title text-center">
              This feedback requires us to verify you.
            </p>

            {!otpSent ? (
              <>
                <div className="green-text">
                  <p>
                    Your email will not be associated to this feedback, or will not be used for any other purpose other than to verify that this feedback is unique and from a valid source.
                  </p>
                </div>
                <input
                  type="email"
                  className="form-control mt-2 mb-2"
                  value={email}
                  id="email"
                  onChange={(e) => setEmail(e.target.value)}
                  placeholder="Enter your email"
                  autoComplete="email"
                  pattern="[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$"
                  required
                />
                <button
                  className="custom-btn custom-btn--center custom-btn--verify"
                  onClick={handleSendOtp}
                  disabled={!email}
                >
                  VERIFY
                </button>
              </>
            ) : (
              <>
                <p>We have sent a 4-digit OTP to <b>{email}</b></p>
                <input
                  type="text"
                  className="form-control mt-2 mb-2"
                  maxLength={4}
                  value={otp}
                  onChange={(e) => setOtp(e.target.value)}
                  placeholder="Enter 4 digit OTP"
                />
                <button
                  className="custom-btn custom-btn--center custom-btn--verify"
                  onClick={handleVerifyOtp}
                  disabled={otp.length !== 4}
                >
                  VALIDATE OTP
                </button>
              </>
            )}
          </div>
        </div>
      </div>
    );
  }
  function renderQuestions() {
    return questions?.length > 0 ? (
      <>
        <Carousel
          swipeable={false}
          showArrows={false}
          showThumbs={false}
          showStatus={false}
          useKeyboardArrows={false}
          selectedItem={activeQuestionIndex}
        >
          {questions.map((item: QuestionInterFace, index: number) => (
            <Question
              key={index}
              ratings={ratings}
              question={item.questionText}
              questionId={item.questionId}
              onRateChange={handleRateChange}
            />
          ))}
        </Carousel>
        <div style={{height: '40px', marginTop: '-10px'}}>
          {progress > 0 && (
            <div className="progress-bar-container">
              <div 
                className="progress-bar-fill" 
                style={{ width: `${progress}%` }}
              />
            </div>
          )}
        </div>
      </>
    ) : (
      <></>
    );
  }

  function renderConfirmation() {
    return (
      <div className="card mt-3 card-shadow mx-3 messagebox">
        <div className="card-body text-center">
          <br />
          <div className="center activity-card middle">
            <span className="input-label">Thank you for your feedback.</span>
            <br />
            <br />
            <button className="custom-btn custom-btn--center">
              <a
                className="downloadApp"
                href={getMobileOperatingSystem()}
                target="_blank"
              >
                Download App
              </a>
            </button>
          </div>
        </div>
      </div>
    );
  }

  function renderBoxMessage(message: string, canClose: boolean) {
    return (
      <div className="card mt-3 card-shadow mx-3 messagebox">
        {canClose ? (
          <a href="/" className="close" onClick={hideAllBoxMessages}></a>
        ) : (
          ""
        )}
        <div className="card-body text-center">
          <div className="center activity-card">
            <span className="input-label">{message}</span>
          </div>
        </div>
      </div>
    );
  }
  return (
    <main>
      <section>
        <div className="container-fluid">
          <div className="card-body-carousel">
            {showAlreadySubmittedError
              ? renderBoxMessage(
                config["FEEDBACK-UI-ALREADY-SUBMITTED-MESSAGE"],
                true
              )
              : ""}
            {showExpiredError
              ? renderBoxMessage(config["FEEDBACK-UI-EXPIRED-MESSAGE"], true)
              : ""}
            {showNotFoundError
              ? renderBoxMessage(config["FEEDBACK-UI-NOTFOUND-MESSAGE"], true)
              : ""}
            {showGenericError
              ? renderBoxMessage(config["FEEDBACK-UI-ERROR-MESSAGE"], true)
              : ""}
            {showInputActivityCodeError
              ? renderBoxMessage(
                config["FEEDBACK-UI-INPUT-VALIDATION-MESSAGE"],
                true
              )
              : ""}
            {loading ? (
              <div className="loading-container">
                <img src={loadingSvg} alt="Loading..." className="loadingSvg" />
              </div>
            ) : (
              <>
                {isData && (
                  <MeetingHeader
                    text={eventName}
                    lastName={lastName}
                    firstName={firstName}
                    description={description}
                    activityType={activityType}
                    activityDateTime={activityDateTime}
                    avatar={avatar}
                    feedbackCount={feedbackCount}
                    activityCount={activityCount}
                    level={level}
                    isPerpetual={perpetualFeedback}
                  />
                )}
                {showConfirmation
                  ? renderConfirmation()
                  : verificationRequired && !verified
                    ? renderVerification()
                    : renderQuestions()}
              </>
            )}
          </div>
          <ToastContainer />
        </div>
      </section>
    </main>
  );
}

export default RatingPage;
